import { useCallback, useContext, useMemo } from "react";
import UserContext from "context/UserContext";
import { useGestionCustomers } from "hooks/useGestionCustomers";
import { useGestionCustomer } from "hooks/useGestionCustomer";
import { canAccessArea, resolveGestionAccess } from "utils/gestion-access";

// Must run inside the Router (useGestionCustomer reads the :customerId param).
// Pass customerId for pages whose route has no :customerId (e.g. the planillero page).
export function useGestionAccess({ customerId } = {}) {
  const { user } = useContext(UserContext);
  const { gestionCustomers, gestionCustomersLoaded } = useGestionCustomers();
  const { customer: routeCustomer } = useGestionCustomer();

  const customer =
    customerId != null && customerId !== ""
      ? (gestionCustomers.find((item) => String(item.id) === String(customerId)) ?? null)
      : routeCustomer;

  const access = useMemo(() => resolveGestionAccess(customer, user), [customer, user]);
  const can = useCallback((area) => canAccessArea(access, area), [access]);

  return { ...access, can, loading: !gestionCustomersLoaded && !customer };
}
